import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import '../styles/RecipeStyles.css';

export function Recipe({ recipe }) {
  const { t } = useTranslation();

  return (
    <section className="recipe" aria-labelledby="recipe-details-heading">
      <h2 id="recipe-details-heading" aria-hidden="true" className="visuallyHidden">
        {t('recipe.details')}
      </h2>

      <section className="container ingredients" aria-labelledby="ingredients-heading">
        <div className="title">
          <h3 id="ingredients-heading">{t('M036')}</h3>
          <p className="info">{`${t('M043')} ${recipe.serves}`}</p>
        </div>
        <div className="body">
          <ul className="list" aria-label={t('recipe.ingredients')}>
            {recipe.ingredients?.map((item, index) => (
              // Static per recipe and lines can repeat, so the text is not a safe key.
              // eslint-disable-next-line react/no-array-index-key
              <li className="item" key={`${index}ingr`}>
                <FontAwesomeIcon icon={faCheckCircle} className="check" />
                <div className="step">{item}</div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="container method" aria-labelledby="method-heading">
        <div className="title">
          <h3 id="method-heading">{t('M041')}</h3>
        </div>
        <div className="body">
          <ol className="list" aria-label={t('recipe.method')}>
            {recipe.method?.map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <li className="item" key={`${index}method`}>
                <div className="number">{index + 1}</div>
                <div className="step">{item.replace(/^\d+\.\s/, '')}</div>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="container nutrition" aria-labelledby="nutrition-heading">
        <div className="title">
          <h3 id="nutrition-heading">{t('recipe.nutrition')}</h3>
          <p className="info">{t('M042')}</p>
        </div>
        <span className="visuallyHidden">
          {`${recipe.kcal} ${t('M044')}, ${recipe.carbs}g ${t('M045')}, ${recipe.fat}g ${t('M046')}, ${recipe.protein}g ${t('M047')}`}
        </span>
        <div className="body" aria-hidden="true">
          <div className="nutri-info">
            <h4 className="kcal">{t('M044')}</h4>
            <div>{recipe.kcal}</div>
          </div>
          <div className="nutri-info">
            <h4 className="carbs">{t('M045')}</h4>
            <div>{recipe.carbs}g</div>
          </div>
          <div className="nutri-info">
            <h4 className="fat">{t('M046')}</h4>
            <div>{recipe.fat}g</div>
          </div>
          <div className="nutri-info">
            <h4 className="protein">{t('M047')}</h4>
            <div>{recipe.protein}g</div>
          </div>
        </div>
      </section>
    </section>
  );
}
